import { render, staticRenderFns } from "./ad-target.vue?vue&type=template&id=6b3b17ee&scoped=true&"
import script from "./ad-target.vue?vue&type=script&lang=js&"
export * from "./ad-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b17ee",
  null
  
)

export default component.exports